
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipContainer as ObiShipContainerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-container.js';
 
 
 

 
 export const ObiShipContainer = createComponent({
   react: React,
   tagName: 'obi-ship-container',
   elementClass: ObiShipContainerElement,
   events: {
     
   }
  });
 
 